import React, { useState, forwardRef } from 'react';

function isValueSelected(value, candidate) {
  if (candidate === undefined || value === undefined) {
    return false;
  }

  if (Array.isArray(candidate)) {
    return candidate.indexOf(value) >= 0;
  }

  return value === candidate;
}

const ButtonGroup = forwardRef(function ToggleButton(props, ref) {
  const {
    children,
    className,
    onChange,
    value,
  } = props;

  const handleChange = (event, buttonValue) => {
    if (!onChange) {
      return;
    }

    onChange(event, value === buttonValue ? null : buttonValue);
  };

  return (
    <div
      role="group"
      className={className}
      ref={ref}
    >
      {React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) {
          return null;
        }

        return React.cloneElement(child, {
          className: child.props.className,
          onChange: handleChange,
          selected:
            child.props.selected === undefined
              ? isValueSelected(child.props.value, value)
              : child.props.selected,
        });
      })}
    </div>
  );
});

export default ButtonGroup;
